// src/utils/esportaXLSX.js
import XLSXStyle from "xlsx-js-style";

export function esportaXLSX(righe, nomeFile, nomeSheet = "Dati") {
  // Normalizza sempre ad array di array (anche se in ingresso sono oggetti)
  let aoa;
  if (Array.isArray(righe[0])) {
    aoa = righe;
  } else {
    const chiavi = Object.keys(righe[0] || {});
    aoa = [chiavi, ...righe.map(r => chiavi.map(k => r[k]))];
  }

  const ws = XLSXStyle.utils.aoa_to_sheet(aoa);

  // Grassetto sulla riga di intestazione (prima riga)
  const nCol = (aoa[0] || []).length;
  const B = { font: { bold: true } };
  for (let c = 0; c < nCol; c++) {
    const addr = XLSXStyle.utils.encode_cell({ r: 0, c });
    if (ws[addr]) ws[addr].s = B;
  }

  // Larghezza colonne adattata al contenuto più lungo (min 8, max 60 caratteri)
  ws["!cols"] = Array.from({ length: nCol }, (_, colIdx) => {
    let max = 8;
    aoa.forEach(riga => {
      const val = riga[colIdx];
      const len = (val === undefined || val === null) ? 0 : String(val).length;
      if (len > max) max = len;
    });
    return { wch: Math.min(max + 2, 60) };
  });

  const wb = XLSXStyle.utils.book_new();
  XLSXStyle.utils.book_append_sheet(wb, ws, nomeSheet);
  XLSXStyle.writeFile(wb, `${nomeFile}.xlsx`);
}
